import { Component, OnInit } from '@angular/core';
import { ThemeOptions } from '../../../../theme-options';
import { select } from '@angular-redux/store';
import { Observable } from 'rxjs';

// Services
import {EncryptService} from "../../../../_shared/encrypt";
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-box',
  templateUrl: './user-box.component.html',
})
export class UserBoxComponent implements OnInit {

  constructor(
    public globals: ThemeOptions,
    private encryptService: EncryptService,
    private router: Router
  ) {
  }

  public userDataComplete = null;


  toggleDrawer() {
    this.globals.toggleDrawer = !this.globals.toggleDrawer;
  }

  ngOnInit() {

    this.userDataComplete = JSON.parse(this.encryptService.decryptData(localStorage.getItem('tp_dataUserComplete')));
  }

  logout() {
    window.localStorage.clear();
    // eliminamos data de usuario en sesión

    this.router.navigate(['/auth/login']);
  }

}
